import makePayload from './makePayload'
import { WebStorage } from 'proxy-storage'
import store from 'utils/store/withMiddleware'
import { productNames } from './getCoverageType'
import makePayloadAddon from './makePayloadAddon'
import { CRM_MIDDLEWARE } from 'core/constants/endpoints'
import { createLead } from '..'
import { fetchJSON } from '@hc-frontend/utils'
import { SFResponse } from '../types'

const sessionStorage = new WebStorage('sessionStorage')

function sendOpportunity(): Promise<[SFResponse, SFResponse[]]> | null {
  const { hcStorage } = store.getState()

  if (!hcStorage.contact || !hcStorage.contact.email_address || !hcStorage.pivotPlan) {
    return null
  }

  const pivotSFLeadId = sessionStorage.getItem(
    `pivotSFLeadId-${hcStorage.contact.email_address}`
  )

  if (pivotSFLeadId) {
    return Promise.all([
      createOpportunity(pivotSFLeadId),
      sendAddOns(hcStorage.addOnSelected)
    ])
  } else {
    return createLead({ email: hcStorage.contact.email_address }).then(function (resp) {
      sessionStorage.setItem(`pivotSFLeadId-${hcStorage.contact.email_address}`, resp.id)

      return Promise.all([
        createOpportunity(resp.id),
        sendAddOns(hcStorage.addOnSelected)
      ])
    })
  }
}

function sendAddOns(addons): Promise<SFResponse[]> | null {
  if (!addons) {
    return null
  }
  const promises = []
  addons.forEach(addon => {
    promises.push(sendAddOnOpportunity(addon))
  })
  return Promise.all(promises)
}

function sendAddOnOpportunity(plan): Promise<SFResponse> {
  const state = store.getState()
  const { hcStorage } = state
  const opportunityId = sessionStorage.getItem(
    `pivotSFAddOn-${productNames[plan.productId]}`
  )
  const leadId = sessionStorage.getItem(
    `pivotSFLeadId-${hcStorage.contact.email_address}`
  )

  const data = makePayloadAddon({ state, plan, leadId, opportunityId })

  return fetchJSON<SFResponse>(`${CRM_MIDDLEWARE}/opportunity`, {
    method: opportunityId ? 'PATCH' : 'POST',
    body: data
  })
    .then(response => response.parsedBody)
    .then(function (resp) {
      if (resp.id) {
        sessionStorage.setItem(`pivotSFAddOn-${productNames[plan.productId]}`, resp.id)
      }
      return resp
    })
}

function createOpportunity(leadId): Promise<SFResponse> {
  const state = store.getState()
  const { hcStorage, quoteKey } = state
  const plan = hcStorage.pivotPlan

  const opportunityId = sessionStorage.getItem(`pivotSFOpportunity-${plan.planId}`)

  const data = makePayload({ quoteKey, hcStorage, plan, leadId, opportunityId })

  return fetchJSON<SFResponse>(`${CRM_MIDDLEWARE}/opportunity`, {
    body: data,
    method: opportunityId ? 'PATCH' : 'POST'
  })
    .then(response => response.parsedBody)
    .then(function (resp) {
      if (resp.id) {
        sessionStorage.setItem(`pivotSFOpportunity-${plan.planId}`, resp.id)
      }
      return resp
    })
}

export { sendOpportunity }
